import { Option } from "../types/Option";

const PublicTransportModes: Option[] = [
  { id: 0, label: "Tram/Streetcar/Light rail" },
  { id: 1, label: "Subway/Metro" },
  { id: 2, label: "Rail" },
  { id: 3, label: "Bus" },
  { id: 4, label: "Ferry" },
  { id: 5, label: "Cable/Tram" },
  { id: 6, label: "Aerial Lift" },
  { id: 7, label: "Funicular" },
  { id: 11, label: "Trolleybus" },
  { id: 12, label: "Monorail" },
  { id: 200, label: "Coach" },
];

export default PublicTransportModes;
